import * as betgalaxy from './MultiCardInput.styles.betgalaxy';
import * as betprofessor from './MultiCardInput.styles.betprofessor';
import * as betroyale from './MultiCardInput.styles.betroyale';
import * as puntcity from './MultiCardInput.styles.puntcity';
import * as puntgenie from './MultiCardInput.styles.puntgenie';
import * as questbet from './MultiCardInput.styles.questbet';
import * as sterlingparker from './MultiCardInput.styles.sterlingparker';
import * as vikingbet from './MultiCardInput.styles.vikingbet';
import * as volcanobet from './MultiCardInput.styles.volcanobet';
import * as wellbet from './MultiCardInput.styles.wellbet';
import * as juicybet from './MultiCardInput.styles.juicybet';
import * as forsport from './MultiCardInput.styles.forsport';
import * as fiestabet from './MultiCardInput.styles.fiestabet';
import * as junglebet from './MultiCardInput.styles.junglebet';
import * as oldgill from './MultiCardInput.styles.oldgill';
import * as buffalobet from './MultiCardInput.styles.buffalobet';
import * as titanbet from './MultiCardInput.styles.titanbet';
import * as slambet from './MultiCardInput.styles.slambet';
import * as sugarcastle from './MultiCardInput.styles.sugarcastle';
import * as gigabet from './MultiCardInput.styles.gigabet';
import * as betstride from './MultiCardInput.styles.betstride';
import * as goldenbet888 from './MultiCardInput.styles.goldenbet888';
import * as hyperbet from './MultiCardInput.styles.hyperbet';
import * as bet777 from './MultiCardInput.styles.bet777';
import * as chromabet from './MultiCardInput.styles.chromabet';
import * as bet575 from './MultiCardInput.styles.bet575';
import * as betblast from './MultiCardInput.styles.betblast';
import * as pyramidbet from './MultiCardInput.styles.pyramidbet';
import * as magnumbet from './MultiCardInput.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  forsport,
  fiestabet,
  junglebet,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  sugarcastle,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
